import { useLocation } from 'react-router';

interface LocationState {
    message?: string;
    errorCode?: string;
}

const ErrorPage: React.FC = () => {
    const location = useLocation<LocationState>();

    const goToAppointment = () => {
        return;
    };

    return (
        <div className="flex relative flex-col w-full h-full bg-white font-grotesk select-none items-center justify-center p-16">
            <svg
                width="48"
                height="48"
                viewBox="0 0 28 28"
                className="fill-status-warning cursor-pointer fill-status-warning"
                preserveAspectRatio="xMidYMid meet"
            >
                <path d="M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z"></path>
            </svg>
            <p>{location?.state?.message || 'Something went wrong'}</p>
            <p className="text-neutral-5 text-12">
                {location?.state?.errorCode ? `Error: ${location?.state?.errorCode}` : ''}
            </p>

            <div className="flex items-center justify-center mt-16">
                <button
                    onClick={goToAppointment}
                    className="inline-flex items-center justify-center w-full px-16 py-10 rounded-32 text-white bg-icons-brand font-700 disabled:bg-background-secondary disabled:text-text-tertiary"
                >
                    Go to my appointments
                </button>
            </div>
        </div>
    );
};

export default ErrorPage;
